
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal-document-storage-for-law-firms",
      function () {
        return require("private-next-pages/legal-document-storage-for-law-firms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal-document-storage-for-law-firms"])
      });
    }
  